import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { CustomerTransactionState } from "../../Slice/Dashboard/CustomerTransaction";
import { getCustomerTransactionAPI } from "../../ApiCalls/Dashboard/CustomerTransationApi";
import { showErrorToast } from "../../../components/atoms/Utlis/Toast";

export const CustomerPaymentReducer = (
  builder: ActionReducerMapBuilder<CustomerTransactionState>
) => {
  builder
    .addCase(getCustomerTransactionAPI.pending, (state) => {
      state.loading = true;

      state.error = {};
    })
    .addCase(
      getCustomerTransactionAPI.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.transactions = action.payload?.results ?? [];
        state.customer_payments = action.payload?.customer_payments ?? null;
        const count = action.payload?.count ?? action.payload?.results?.length ?? 0;
        const pageSize = action.payload?.page_size ?? 10;
        const totalPages =
          action.payload?.total_pages ??
          (pageSize > 0 ? Math.ceil(count / pageSize) : 1);
        const currentPage = action.payload?.page ?? 1;

        state.count = count;
        state.total_pages = Math.max(1, totalPages);
        state.current_page = currentPage;
        state.page_size = pageSize;
      }
    )
    .addCase(
      getCustomerTransactionAPI.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;

        if (action.payload && action.payload.message) {
          showErrorToast(action.payload.message);
        } else {
          console.log(action.payload);
        }
      }
    );
};
